import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
// @ts-ignore
import styles from 'SUKLCredentialsHint.module.scss';

interface Props {
	onConfirm: () => void;
}

const SUKLCredentialsHint: React.FC<Props> = ({ onConfirm }) => {
	return (
		<div className={styles.wrapper}>
			<Text tx='component.certificates.suklLoginWhere' />
			<Text tx='component.certificates.clickOnLink' />
			<LinkButton
				title='https://pristupy.sukl.cz/ei_forms.html#/login'
				href=' https://pristupy.sukl.cz/ei_forms.html#/login'
				theme={Theme.BLUE}
			/>
			<Text tx='component.certificates.suklLoginInstructions' />
			<img src='/dist/hint/suklCredentials.jpg' alt='sukl hint' />
			<Text tx='component.certificates.suklLoginInstructions2' />
			<Button
				theme={Theme.GREEN}
				title='base.shared.ok'
				onClick={onConfirm}
				className={styles.button}
			/>
		</div>
	);
};

export default SUKLCredentialsHint;
